// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"76":"actioncable","970":"lottie"}[chunkId] + "-" + {"76":"776ca48c0b40fc59452f","970":"d710116ab10ca3bc658b"}[chunkId] + ".chunk.js";
};